export function computeReadiness(sections, responses) {
  let totalItems = 0;
  let resolvedItems = 0;
  const sectionScores = [];
  
  (sections || []).forEach(sec => {
    if (sec.id === "legal_review_required") return; // skip legal for standard readiness
    let sectionTotal = 0;
    let sectionResolved = 0;
    sec.items?.forEach(item => {
      totalItems++;
      sectionTotal++;
      const s = responses[item.id]?.status;
      if (s === "Acceptable" || s === "Not Applicable") {
        resolvedItems++;
        sectionResolved++;
      }
    });
    sectionScores.push({
      id: sec.id,
      title: sec.title,
      pct: sectionTotal === 0 ? 0 : Math.round((sectionResolved / sectionTotal) * 100),
      resolvedItems: sectionResolved,
      totalItems: sectionTotal,
    });
  });
  
  const pct = totalItems === 0 ? 0 : Math.round((resolvedItems / totalItems) * 100);
  return { pct, resolvedItems, totalItems, sections: sectionScores };
}
